// extracted by mini-css-extract-plugin
export default {"numberInputField":"numberInputField__MjQ3M"};